export interface DynamicConfig {
    environment: "DEV" | "TEST" | "PROD";
    XDATA_GRID_PRO_LICENSE: string;
    STORAGE_CONTAINER_URL: string;
    FLAG_URL_PREFIX: string;
    BRANDS_URL_PREFIX: string;
    CHEF_PHOTOS_URL_PREFIX: string;
    HOSTNAME: string;
    AZURE_STORAGE_SAS_TOKEN: string;
    AZURE_STORAGE_ACCOUNT_NAME: string;
    AZURE_STORAGE_CONTAINER: string;
    ALGOLIA_APP_ID: string;
    ALGOLIA_API_ADMIN_KEY: string;
    ALGOLIA_INDEX_NAME: string;
    EMAIL_LOGO_GRIFFITH: string;
    EMAIL_LOGO_CC: string;
    EMAIL_LOGO_TEROVA: string;
    EMAIL_LOGO_NOURISH: string;
    EMAIL_SUBHEADLINE: string;
    EMAIL_INTRO_TEXT: string;
    EMAIL_FEATURE_IMAGE: string;
  }
  
  export const defaultConfig: DynamicConfig = {
    environment: "DEV",
    XDATA_GRID_PRO_LICENSE: "c7333753ae4fc2f8535fba6a7df351ddT1JERVI6MzkxMDcsRVhQSVJZPTE2NzgxMzQzMjAwMDAsS0VZVkVSU0lPTj0x",
    STORAGE_CONTAINER_URL: "https://mirondevblobstorage.blob.core.windows.net",
    FLAG_URL_PREFIX: "https://mirondevblobstorage.blob.core.windows.net/market-launch/images/country-flags/",
    BRANDS_URL_PREFIX: "https://mirondevblobstorage.blob.core.windows.net/market-launch/images/brand-logos/",
    CHEF_PHOTOS_URL_PREFIX: "https://mirondevblobstorage.blob.core.windows.net/market-launch/images/chef-photos/",
    HOSTNAME: "flavoriq.miron.services",
    AZURE_STORAGE_SAS_TOKEN: "sp:racwo&st:2025-01-08T20:37:31Z&se:2035-01-09T04:37:31Z&spr:https&sv:2022-11-02&sr:c&sig:%2Bvz13OztPeAjH0W8B2jOcjbn9nsCwBf%2Fz02jIbrf2uI%3D",
    AZURE_STORAGE_ACCOUNT_NAME: "mirondevblobstorage",
    AZURE_STORAGE_CONTAINER: "market-launch",
    ALGOLIA_APP_ID: "3I2GG0TWY6",
    ALGOLIA_API_ADMIN_KEY: "10249cc5735a04388b67ce71bf2fe7d6",
    ALGOLIA_INDEX_NAME: "dev.marketlaunch.flavoriq.global",
    EMAIL_LOGO_GRIFFITH: "/market-launch/images/emails/global/logo-griffith.png",
    EMAIL_LOGO_CC: "/market-launch/images/emails/global/logo-custom-culinary.png",
    EMAIL_LOGO_TEROVA: "/market-launch/images/emails/global/logo-terova.png",
    EMAIL_LOGO_NOURISH: "/market-launch/images/emails/global/logo-nourish.png",
    EMAIL_SUBHEADLINE: "<i>Market Launch Powered By FlavorIQ</i><sup style=\"font-size:24px;\"> ®</sup>",
    EMAIL_INTRO_TEXT: "We are excited to share some of our latest wins!<br/>Please contact your local team for more information.",
    EMAIL_FEATURE_IMAGE: "https://mirondevblobstorage.blob.core.windows.net/market-launch/images/emails/global/header-1.jpg",
  };
  
  
  export const dynamicConfigUrl = "config.json";
  